var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemIconPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99988 6.0003V26H9.92437V24.5618H7.44117V14.0531H10.9665V15.8893H12.4077V10.9114H10.9665V12.615H7.44117V7.43799H16.0219V14.053H22.7626V12.615H17.4635V7.43799H24.5587V18.8758H19.7697V20.3138H24.5587V24.5615H14.2929V25.9997H25.9999V6L5.99988 6.0003Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemIconPlan);
export default __webpack_public_path__ + "static/media/itemIconPlan.9787d50848f7ed68e0ebfbed2f10dcdd.svg";
export { ForwardRef as ReactComponent };